import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SEO_DEFAULTS, useContent } from "@/lib/content";

const PUBLIC_PAGE_KEYS = {
  "/": "home",
  "/inventory": "inventory",
  "/specials": "specials",
  "/concierge": "concierge",
  "/contact": "contact",
  "/privacy": "privacy",
  "/terms": "terms",
};

const setMeta = (selector, attribute, value) => {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    const [name, content] = attribute;
    element.setAttribute(name, content);
    document.head.appendChild(element);
  }
  element.setAttribute("content", value);
};

export const SeoManager = () => {
  const location = useLocation();
  const seo = useContent("seo", SEO_DEFAULTS);

  useEffect(() => {
    const pageKey = location.pathname.startsWith("/vehicles/")
      ? "vehicle"
      : PUBLIC_PAGE_KEYS[location.pathname];
    const isPublic = Boolean(pageKey);
    const title = isPublic
      ? seo[`${pageKey}_title`] || seo.site_title
      : seo.site_title;
    const description = isPublic
      ? seo[`${pageKey}_description`] || seo.default_description
      : seo.default_description;
    const baseUrl = (seo.site_url || window.location.origin).replace(/\/$/, "");
    const canonicalUrl = `${baseUrl}${location.pathname}`;
    const robots = isPublic ? seo.robots || "index,follow" : "noindex,nofollow";

    document.title = title;
    setMeta('meta[name="description"]', ["name", "description"], description);
    setMeta('meta[name="robots"]', ["name", "robots"], robots);
    setMeta('meta[property="og:title"]', ["property", "og:title"], title);
    setMeta('meta[property="og:description"]', ["property", "og:description"], description);
    setMeta('meta[property="og:url"]', ["property", "og:url"], canonicalUrl);
    setMeta('meta[property="og:type"]', ["property", "og:type"], "website");
    setMeta('meta[name="twitter:card"]', ["name", "twitter:card"], "summary_large_image");
    if (seo.default_share_image) {
      setMeta(
        'meta[property="og:image"]',
        ["property", "og:image"],
        seo.default_share_image,
      );
    }

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", canonicalUrl);
  }, [location.pathname, seo]);

  return null;
};